import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import ApiService from '@/services/api.service'

Vue.use(VueRouter)


const requireAuth = function (to, from, next) {
  if (!store.getters['auth/isLoggedIn']) {
    store.dispatch('auth/logout').then(() => {
      next({ name: 'login', query: { redirect: to.fullPath } })
    })
  } else {
    next()
  }
}

const requireGuest = function (to, from, next) {
  if (store.getters['auth/isLoggedIn']) {
      next({ name: 'user' })
  } else {
      next()
  }
}

const logout = function (to, from, next) {
  ApiService.logout('/users/logout') // for logging purposes
    .then(()  => {
      store.dispatch('auth/logout').then(() => {
        next({ name: 'login' })
      })
    })
}

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'dashboard' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    beforeEnter: requireGuest,
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/ResetPassword.vue'),
    beforeEnter: requireGuest,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/patients',
    name: 'patients',
    component: () => import('@/views/Patients.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/patient/:patientId?',
    name: 'patient',
    component: () => import('@/views/Patient.vue'),
    props: true,
    beforeEnter: requireAuth,
  },
  {
    path: '/report-milk-project-list',
    name: 'report-milk-project-list',
    component: () => import('@/views/reports/MilkProjectList.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-milk-project-monthly',
    name: 'report-milk-project-monthly',
    component: () => import('@/views/reports/MilkProjectMonthly.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-speech-therapy-prep',
    name: 'report-speech-therapy-prep',
    component: () => import('@/views/reports/SpeechTherapyPrep.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-speech-therapy-stats',
    name: 'report-speech-therapy-stats',
    component: () => import('@/views/reports/SpeechTherapyStats.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-psychology-prep',
    name: 'report-psychology-prep',
    component: () => import('@/views/reports/PsychologyPrep.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-surgery',
    name: 'report-surgery',
    component: () => import('@/views/reports/Surgery.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-dental',
    name: 'report-dental',
    component: () => import('@/views/reports/Dental.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-medical-checkup',
    name: 'report-medical-checkup',
    component: () => import('@/views/reports/MedicalCheckup.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-evaluation',
    name: 'report-evaluation',
    component: () => import('@/views/reports/Evaluation.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-total-export',
    name: 'report-total-export',
    component: () => import('@/views/reports/TotalExport.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/report-tess-statistics',
    name: 'report-tess-statistics',
    component: () => import('@/views/reports/TessStatistics.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/master-files/:masterFileTypeTag',
    name: 'master-files',
    component: () => import('@/views/MasterFiles.vue'),
    props: true,
    beforeEnter: requireAuth,
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/Users.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/stock/:location',
    name: 'stock',
    component: () => import('@/views/Stock.vue'),
    props: true,
    beforeEnter: requireAuth,
  },
  {
    path: '/translation',
    name: 'translation',
    component: () => import('@/views/Translation.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/Setting.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/user-log',
    name: 'user-log',
    component: () => import('@/views/UserLog.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: logout,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
